<template>
  <div class="email-field">
    <div class="email-field__title dea-heading--medium-xs">
      <div class="email-field__title-label">
        {{ title.toUpperCase() }}
      </div>
    </div>
    <div v-for="(mail, index) in mailsList" :key="index" class="email-field__item">
      <div class="email-field__item-content">
        <div class="email-field__content-label dea-heading--regular-m">
          {{ mail }}
        </div>
        <Links
          class="email-field__item-content-link dea-links--large"
          :class="`dea-links--${linkColor}`"
          @click="$emit('open-modify', { mail, mode: 'modify' })"
        >
          Modifica
        </Links>
      </div>
      <div v-if="mailsList.length > 1" class="email-field__item-remove-email">
        <Links
          class="email-field__item-content-link dea-links--large"
          @click="$emit('open-modify', { mail, mode: 'delete' })"
        >
          Rimuovi email
        </Links>
      </div>
      <div v-if="!isChildren && index === 0" class="email-field__item-description">
        <div class="dea-heading--regular-s">
          Questo è l'indirizzo a cui ti scriveremo: aggiungi info@deascuola.it ai tuoi contatti per non perderti i
          nostri messaggi.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";

export default {
  name: "EmailField",
  components: { Links },
  props: {
    isChildren: {
      type: Boolean,
      default: false,
    },
    linkColor: {
      type: String,
      default: "",
    },
    mailsList: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      required: "",
    },
    showRemoveEmail: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    label() {
      if (this.field) {
        return this.field;
      }
      return this.placeholder;
    },
    link() {
      if (this.field) {
        return "Modifica";
      }
      return "Aggiungi";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.email-field {
  @include media("<=s") {
    margin-top: $space-x-large;
  }
  margin-bottom: $space-large;
  margin-top: $space-xx-large;

  &__title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: $space-x-small;
  }

  &__item {
    margin: $space-x-small 0;

    &-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      &-link {
        cursor: pointer;
      }
    }

    &-remove-email {
      display: flex;
      flex-direction: row-reverse;
      margin-top: $space-x-small;
    }

    &-description {
      margin-bottom: $space-small;
      margin-top: $space-x-small;
    }
  }
}
</style>
